import React, { useState } from "react";
import ReactDOM  from 'react-dom/client';
import { BrowserRouter, Routes, Route} from "react-router-dom";
import { useNavigate,useLocation } from "react-router-dom";
import {useEffect} from "react";
import axios from "axios";
const EditNurse = () => {
    const location = useLocation();
    const uata = location.state?.uata;
     useEffect(() => {
        const scriptUrls = [
          'assets/js/jquery.min.js',
'assets/js/bootstrap.bundle.min.js',
'assets/js/moment.min.js',
'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
'assets/vendor/overlay-scroll/custom-scrollbar.js',
'assets/vendor/daterange/daterange.js',
'assets/vendor/daterange/custom-daterange.js',
'assets/vendor/dropzone/dropzone.min.js',
'assets/vendor/quill/quill.min.js',
'assets/vendor/quill/custom.js',
'assets/js/custom.js'
        ];
    
        let isCancelled = false;
    
        // Load scripts sequentially
        const loadScriptsSequentially = async () => {
          for (const url of scriptUrls) {
            if (isCancelled) break;
    
            await new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = url;
              script.onload = resolve;
              script.onerror = reject;
              document.body.appendChild(script);
            });
          }
        };
    
        loadScriptsSequentially();
    
        return () => {
          isCancelled = true;
          // Optionally remove scripts if needed
        };
      }, []);
    const [depName, setDepName] = useState('');
       const [depEmail, setDepEmail] = useState('');
       const [depHead, setDepHead] = useState('');
       const [depPhone, setDepPhone] =useState('');
       const [noRooms, setNoRooms] = useState('');
       const [noBeds, setNoBeds] =useState('');
       const [status, setStatus] = useState('');
       const [message, setMessage] = useState('');
    const navigator = useNavigate();

    function handleUpdate(e){
      e.preventDefault();
      
      const formData = new FormData();
      
      formData.append("jsonData" , JSON.stringify({
        "dep_name":depName,
        "dep_email":depEmail,
        "dep_head":depHead,
        "dep_Phone":depPhone,
        "no_rooms":noRooms,
        "no_beds":noBeds,
        "status":status,
        "message":message,
      }));
      
      console.log();
    const REST_API_BASE_URL = `http://localhost:8080/api/listBooks/${uata}`;
    const EnterNurse =() => axios.get(REST_API_BASE_URL);
    EnterNurse(formData).then((response) =>{
        console.log(response.data);
        navigator("/view-users");
      })

    }
    const [company, setCompany] = useState([]);
        const srcImg="http://localhost:8080/Images/";
        useEffect(() =>{
            const REST_API_BASE_URL = `http://localhost:8080/api/listBooksByUsers`;
            const updateCompany =() => axios.get(REST_API_BASE_URL);
            updateCompany().then((response) => {
                setCompany(response.data);
            }).catch(error =>{
                console.error(error);
            })
        } , [])
  return(   
<div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="index-2.html">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Edit Nurses
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div>
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            {/* Custom tabs starts */}
            <div className="custom-tabs-container">
              {/* Nav tabs starts */}
              <ul className="nav nav-tabs" id="customTab2" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link active" id="tab-oneA" data-bs-toggle="tab" href="#oneA" role="tab" aria-controls="oneA" aria-selected="true"><i className="ri-briefcase-4-line" /> Personal
                    Details</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-twoA" data-bs-toggle="tab" href="#twoA" role="tab" aria-controls="twoA" aria-selected="false"><i className="ri-account-pin-circle-line" />
                    Profile and Bio</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-threeA" data-bs-toggle="tab" href="#threeA" role="tab" aria-controls="threeA" aria-selected="false"><i className="ri-calendar-check-line" />
                    Availability</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-fourA" data-bs-toggle="tab" href="#fourA" role="tab" aria-controls="fourA" aria-selected="false"><i className="ri-lock-password-line" /> Account
                    Details</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-fiveA" data-bs-toggle="tab" href="#fiveA" role="tab" aria-controls="fiveA" aria-selected="false"><i className="ri-lock-password-line" />
                    Permissions</a>
                </li>
              </ul>
              {/* Nav tabs ends */}
              {/* Tab content starts */}
              <div className="tab-content">
                <div className="tab-pane fade show active" id="oneA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row gx-4">
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a1">First Name <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-account-circle-line" />
                          </span>
                          <input type="text" className="form-control" id="a1" defaultValue="David" />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a2">Last Name <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-account-circle-line" />
                          </span>
                          <input type="text" className="form-control" id="a2" defaultValue="Miller" />
                        </div>
                      </div>
                    </div>
                    <div className=" col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a3">Age <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flower-line" />
                          </span>
                          <select className="form-select" id="a3">
                            <option value={0}>48</option>
                            <option value={1}>1</option>
                            <option value={2}>2</option>
                            <option value={3}>3</option>
                            <option value={4}>4</option>
                            <option value={5}>5</option>
                            <option value={6}>6</option>
                            <option value={7}>7</option>
                            <option value={8}>8</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="selectGender1">Gender<span className="text-danger">*</span></label>
                        <div className="m-0">
                          <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="selectGenderOptions" id="selectGender1" defaultValue="male" defaultChecked />
                            <label className="form-check-label" htmlFor="selectGender1">Male</label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="selectGenderOptions" id="selectGender2" defaultValue="female" />
                            <label className="form-check-label" htmlFor="selectGender2">Female</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a4">Create ID <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-secure-payment-line" />
                          </span>
                          <input type="text" className="form-control" id="a4" defaultValue="#45489" />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a5">Email ID <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-mail-open-line" />
                          </span>
                          <input type="email" className="form-control" id="a5" defaultValue="test@testing.com" />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a6">Mobile Number <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a6" defaultValue={""} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a7">Marital Status</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-vip-crown-2-line" />
                          </span>
                          <select className="form-select" id="a7">
                            <option value={0}>Married</option>
                            <option value={2}>Unmarried</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a8">Qualification</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-copper-diamond-line" />
                          </span>
                          <select className="form-select" id="a8">
                            <option value={0}>MSc.</option>
                            <option value={1}>BSc.</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a9">Designation</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-nft-line" />
                          </span>
                          <select className="form-select" id="a9">
                            <option value={0}>Select</option>
                            <option value={1}>Nurse</option>
                                                      </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a10">Blood Group<span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-drop-line" />
                          </span>
                          <select className="form-select" id="a10">
                            <option value={0}>O+</option>
                            <option value={1}>A+</option>
                            <option value={2}>A-</option>
                            <option value={3}>B+</option>
                            <option value={4}>B-</option>
                            <option value={5}>O+</option>
                            <option value={6}>O-</option>
                            <option value={7}>AB+</option>
                            <option value={8}>AB-</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a11">Address</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-projector-line" />
                          </span>
                          <textarea className="form-control" id="a15" placeholder="Enter Address" rows={2} defaultValue={""} required/>
                          </div>
                      </div>
                    </div>
                   
                  </div>
                  {/* Row ends */}
                </div>
                <div className="tab-pane fade" id="twoA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row gx-4">
                    <div className="col-sm-2">
                      <div className="mb-3">
                        <img src="assets/images/doctor3.png" className="img-fluid rounded-2" alt="Dentist Dashboard" />
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div id="dropzone" className="mb-3">
                        <form className="dropzone dz-clickable" id="demo-upload">
                          <div className="dz-message">
                            <button type="button" className="dz-button">
                              Upload new photo.</button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div id="fullEditor">
                        <h1>Hello,</h1>
                        <br />
                        <p>My name is <strong>Dr. Alan Stern</strong>, MD: Born in DuBois,
                          Pennsylvania, Dr. Stern graduated from Villanova University and Thomas Jefferson
                          University in Philadelphia. His residency was at Thomas Jefferson and its
                          affiliated
                          Wills Eye. I provide compassionate and personalized care to each of my patients.
                          Specializing in lifesaving surgeries and dedicated to delivering optimal patient
                          outcomes.</p>
                      </div>
                    </div>
                  </div>
                  {/* Row ends */}
                </div>
                <div className="tab-pane fade" id="threeA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row gx-4">
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="d1">Sunday</label>
                        <div className="input-group">
                        <select className="form-select" id="d2">
                            <option value={0}>9AM</option>
                            <option value={1}>5PM</option>
                            <option value={2}>1AM</option>
                          </select>
                          <select className="form-select" id="d2X">
                            <option value={0}>5PM</option>
                            <option value={1}>1AM</option>
                            <option value={2}>9AM</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="d2">Monday</label>
                        <div className="input-group">
                          <select className="form-select" id="d2">
                            <option value={0}>9AM</option>
                            <option value={1}>5PM</option>
                            <option value={2}>1AM</option>
                          </select>
                          <select className="form-select" id="d2X">
                            <option value={0}>5PM</option>
                            <option value={1}>1AM</option>
                            <option value={2}>9AM</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="d3">Tuesday</label>
                        <div className="input-group">
                        <select className="form-select" id="d2">
                            <option value={0}>9AM</option>
                            <option value={1}>5PM</option>
                            <option value={2}>1AM</option>
                          </select>
                          <select className="form-select" id="d2X">
                            <option value={0}>5PM</option>
                            <option value={1}>1AM</option>
                            <option value={2}>9AM</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="d4">Wednesday</label>
                        <div className="input-group">
                        <select className="form-select" id="d2">
                            <option value={0}>9AM</option>
                            <option value={1}>5PM</option>
                            <option value={2}>1AM</option>
                          </select>
                          <select className="form-select" id="d2X">
                            <option value={0}>5PM</option>
                            <option value={1}>1AM</option>
                            <option value={2}>9AM</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="d5">Thursday</label>
                        <div className="input-group">
                        <select className="form-select" id="d2">
                            <option value={0}>9AM</option>
                            <option value={1}>5PM</option>
                            <option value={2}>1AM</option>
                          </select>
                          <select className="form-select" id="d2X">
                            <option value={0}>5PM</option>
                            <option value={1}>1AM</option>
                            <option value={2}>9AM</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="d6">Friday</label>
                        <div className="input-group">
                        <select className="form-select" id="d2">
                            <option value={0}>9AM</option>
                            <option value={1}>5PM</option>
                            <option value={2}>1AM</option>
                          </select>
                          <select className="form-select" id="d2X">
                            <option value={0}>5PM</option>
                            <option value={1}>1AM</option>
                            <option value={2}>9AM</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="d7">Saturday</label>
                        <div className="input-group">
                        <select className="form-select" id="d2">
                            <option value={0}>9AM</option>
                            <option value={1}>5PM</option>
                            <option value={2}>1AM</option>
                          </select>
                          <select className="form-select" id="d2X">
                            <option value={0}>5PM</option>
                            <option value={1}>1AM</option>
                            <option value={2}>9AM</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row ends */}
                </div>
                <div className="tab-pane fade" id="fourA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row gx-4 justify-content-center">
                    <div className="col-sm-4">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="u1">User Name</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-account-pin-circle-line" />
                          </span>
                          <input type="text" id="u1" defaultValue="apollo99" className="form-control" />
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label" htmlFor="u2">New Password</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-lock-password-line" />
                          </span>
                          <input type="password" id="u2" className="form-control" defaultValue="***********#9" />
                          <button className="btn btn-outline-secondary" type="button">
                            <i className="ri-eye-line" />
                          </button>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label" htmlFor="u3">Confirm New Password</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-lock-password-line" />
                          </span>
                          <input type="password" id="u3" defaultValue="***********#9" className="form-control" />
                          <button className="btn btn-outline-secondary" type="button">
                            <i className="ri-eye-off-line" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row ends */}
                </div>
                <div className="tab-pane fade" id="fiveA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row gx-4 justify-content-center">
                    <div className="col-sm-8 col-12">
                      <div>
                        <h5>Module Access</h5>
                        <p>Defines working hours, available departments, offered services, staff structure, supported languages, and currency settings to tailor daily hospital operations efficiently.</p>
                      </div>
                      <div className="list-group w-auto mb-5">
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box sm bg-secondary rounded-3">
                            <i className="ri-phone-line text-dark fs-4" />
                          </div>
                          <div>
                            <h6>Appointments</h6>
                            <p className="m-0">
                              You can update new appointment notifications here.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n1" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box sm bg-secondary rounded-3">
                            <i className="ri-mail-send-line text-dark fs-4" />
                          </div>
                          <div>
                            <h6>Prescriptions</h6>
                            <p className="m-0">
                              You can give priscriptions.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n2" defaultChecked />
                          </div>
                        </div>
                       
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box sm bg-secondary rounded-3">
                            <i className="ri-radio-2-line text-dark fs-4" />
                          </div>
                          <div>
                            <h6>Stocks &amp; inventory</h6>
                            <p className="m-0">
                              You can manage stocks and inventories.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n4" />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box sm bg-secondary rounded-3">
                            <i className="ri-macbook-line text-dark fs-4" />
                          </div>
                          <div>
                            <h6>OPD</h6>
                            <p className="m-0">
                              Enable OPD editions facilities.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n5" />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box sm bg-secondary rounded-3">
                            <i className="ri-mail-send-line text-dark fs-4" />
                          </div>
                          <div>
                            <h6>IPD</h6>
                            <p className="m-0">
                              Enable IPD facilities.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n6" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box sm bg-secondary rounded-3">
                            <i className="ri-chat-1-line text-dark fs-4" />
                          </div>
                          <div>
                            <h6>Pathology</h6>
                            <p className="m-0">
                              Enable pathologies sevices.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n7" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box sm bg-secondary rounded-3">
                            <i className="ri-emoji-sticker-line text-dark fs-4" />
                          </div>
                          <div>
                            <h6>Blood Banks</h6>
                            <p className="m-0">
                              Enable blood bank services.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n8" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box sm bg-secondary rounded-3">
                            <i className="ri-emoji-sticker-line text-dark fs-4" />
                          </div>
                          <div>
                            <h6>Pharmacy</h6>
                            <p className="m-0">
                              Enable pharmacy services.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n8" defaultChecked />
                          </div>
                        </div>
                        
                      </div>
                    </div>
                    <div className="col-sm-12 col-12">
                      <div>
                        <h5>Module Permissions</h5>
                        <p>Defines working permissions like read write and etc.</p>
                      </div>
                      <div class="card-body">
                    <div class="table-outer">
                      <div class="table-responsive">
                        <table class="table truncate m-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Module Permission</th>
                              <th>Read</th>
                              <th>Write</th>
                              <th>Create</th>
                              <th>Delete</th>
                              <th>Import</th>
                              <th>Export</th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>Prescriptions</td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td>
                              <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div>
                              </td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td>
                              <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div>
                              </td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                             
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>Appointments</td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td>
                              <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div>
                              </td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td>
                              <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div>
                              </td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>Lab Reports</td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td>
                              <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div>
                              </td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td>
                              <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div>
                              </td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                             
                            </tr>
                            <tr>
                              <td>4</td>
                              <td>User Roles</td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td>
                              <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div>
                              </td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                              <td>
                              <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div>
                              </td>
                              <td><div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                      <label class="form-check-label" for="inlineCheckbox1"></label>
                    </div></td>
                             
                            </tr>
                           
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                    </div>
                  </div>
                  {/* Row ends */}
                </div>
              </div>
              {/* Tab content ends */}
            </div>
            {/* Custom tabs ends */}
            {/* Card acrions starts */}
            <div className="d-flex gap-2 justify-content-end mt-4">
              <a href="#!" className="btn btn-outline-secondary">
                Cancel
              </a>
              <a href="/view-doctors" className="btn btn-primary" onClick={handleUpdate}>
                Update Profile
              </a>
            </div>
            {/* Card acrions ends */}
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
  </div>
  {/* App body ends */}
</div>

  );
}
export default EditNurse;




